// extracted by mini-css-extract-plugin
export var container = "_1q-0";
export var disabled = "_1q-4";
export var fullWidth = "_1q-3";
export var lined = "_1q-1";
export var selected = "_1q-5";
export var tab = "_1q-2";